import { useState } from "react";
import { ChevronLeft, ChevronRight, Sparkles, Users } from "lucide-react";

const services = [
  {
    title: "Private Sound Healing",
    description:
      "Customizable one-on-one sound healing sessions tailored to your specific ailments and wellness goals. Experience deep relaxation and healing through personalized vibrational therapy.",
    features: ["Personalized approach", "Flexible scheduling", "Focused healing"],
    image: "/IMG_6306.jpg",
    icon: Sparkles,
  },
  {
    title: "Group Sound Healing",
    description:
      "Join our transformative group sound healing sessions. Immerse yourself in healing vibrations alongside a community of seekers in a peaceful, supportive environment.",
    features: ["Community healing", "Shared energy", "Affordable rates"],
    image: "/IMG_6332.jpg",
    icon: Users,
  },
];

const SoundHealingSection = () => {
  const [active, setActive] = useState(0);
  const service = services[active];

  return (
    <section data-testid="sound-healing-section" className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto">
      <div className="mb-16">
        <p className="text-xs uppercase tracking-[0.25em] text-[#596B5B] mb-3 font-medium">
          Offerings
        </p>
        <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-[#1A3626] tracking-tight">
          Sound Healing Services
        </h2>
        <p className="mt-4 text-sm text-[#596B5B] max-w-lg leading-relaxed">
          Customized healing sessions to restore balance and harmony
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
        {/* Image */}
        <div className="relative overflow-hidden rounded-lg">
          <img
            data-testid={`sound-healing-image-${active}`}
            src={service.image}
            alt={service.title}
            className="w-full h-[400px] md:h-[500px] object-cover transition-all duration-500"
          />
        </div>

        {/* Content */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <service.icon size={20} className="text-[#CC5543]" />
            <span className="text-xs uppercase tracking-[0.2em] text-[#596B5B] font-medium">
              {active === 0 ? "Private" : "Group"}
            </span>
          </div>
          <h3 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl font-light text-[#1A3626] mb-4 tracking-tight">
            {service.title}
          </h3>
          <p className="text-sm text-[#596B5B] leading-relaxed mb-6">{service.description}</p>

          <ul className="space-y-3 mb-8">
            {service.features.map((f, i) => (
              <li key={i} className="flex items-center gap-3 text-sm text-[#1A3626]">
                <span className="w-1 h-1 rounded-full bg-[#CC5543]" />
                {f}
              </li>
            ))}
          </ul>

          <a
            data-testid={`book-session-btn-${active}`}
            href="mailto:coral.dozaguass@gmail.com?subject=Book Sound Healing Session"
            className="inline-block px-8 py-3.5 bg-[#CC5543] text-white text-xs uppercase tracking-[0.2em] font-medium rounded-full hover:bg-[#A94334] transition-all duration-300"
          >
            Book This Session
          </a>

          {/* Navigation */}
          <div className="flex items-center gap-4 mt-8">
            <button
              data-testid="sound-healing-prev-btn"
              onClick={() => setActive(active === 0 ? services.length - 1 : active - 1)}
              className="w-10 h-10 rounded-full border border-[#DCD6CC] flex items-center justify-center text-[#596B5B] hover:bg-[#EBE6DF] hover:text-[#1A3626] transition-all"
            >
              <ChevronLeft size={18} />
            </button>
            <span className="text-xs text-[#596B5B] tracking-wider">
              {active + 1} / {services.length}
            </span>
            <button
              data-testid="sound-healing-next-btn"
              onClick={() => setActive(active === services.length - 1 ? 0 : active + 1)}
              className="w-10 h-10 rounded-full border border-[#DCD6CC] flex items-center justify-center text-[#596B5B] hover:bg-[#EBE6DF] hover:text-[#1A3626] transition-all"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SoundHealingSection;
